<!--

    Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<header class="border-b-ozggray-300 flex items-center justify-between border-b bg-white px-9 py-2" data-test-id="info-header">
  <a
    class="hover:border-primary focus-visible:outline-focus w-20 rounded-sm border-2 border-transparent p-1 focus-visible:border-gray-200 focus-visible:outline-2 focus-visible:outline-offset-2"
    aria-label="OZG-Cloud Information"
    routerLink="/"
  >
    <ods-icon name="ozg-logo" size="full" />
  </a>
</header>
<div class="relative flex w-full flex-auto flex-col justify-center gap-14 p-6">
  <main class="bg-background-50 flex-auto">
    <router-outlet></router-outlet>
  </main>
  @if (!isBayern) {
    <footer class="ozg-prose flex justify-center gap-4" data-test-id="navigation-footer">
      <nav>
        <ul class="flex flex-wrap justify-center gap-9">
          <li>
            <a routerLink="/barrierefreiheit">Barrierefreiheit</a>
          </li>
          <li>
            <a routerLink="/impressum">Impressum</a>
          </li>
        </ul>
      </nav>
    </footer>
  }
</div>
